import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { FullModalPage } from './full-modal';

@NgModule({
  declarations: [
    FullModalPage,
  ],
  imports: [
    RouterModule,
    CommonModule,
    IonicModule.forRoot(),
  ],
})
export class FullModalPageModule {}
